<template>
  <div style="display: contents">
    <v-btn
      v-if="!noBtn"
      fab fixed bottom right x-large
      @click.stop="open"
      color="#152047"
    >
      <v-avatar
        color="white"
        class="ma-1"
        size="64"
      >
        <v-img
          src="https://vblimages.blob.core.windows.net/images/1eb7cadf-fa63-4b75-b510-1d1d8981ee03.png" alt="ntdp"
          contain
        ></v-img>
      </v-avatar>
    </v-btn>
    <v-navigation-drawer
      right
      v-model="isOpen"
      fixed temporary
      :width="$vuetify.breakpoint.xs ? 350 : 500"
      :permanent="dirty"
    >
      <!-- HEADER -->
      <template v-slot:prepend>
        <v-toolbar color="#152047" tile dense>
          <v-toolbar-title class="white--text">USA National Team Development Program</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            color="#ca9700"
            class="white--text"
            fab
            small
            @click.stop="cancel(true)"
          >
            <v-icon small>fas fa-times</v-icon>
          </v-btn>
        </v-toolbar>
      </template>
      <!-- FOOTER -->
      <template v-slot:append>
        <v-divider></v-divider>
        <v-card-actions>
          <v-row dense>
            <v-col cols="6">
              <v-btn
                :color="activeBtn.color"
                :disabled="activeBtn.disabled"
                :loading="activeBtn.loading"
                @click.stop="activeBtn.onClick"
                block
                class="py-9"
              >
                {{ activeBtn.text }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="error white--text"
                @click.stop="activeBtn.cancel"
                :disabled="loading"
                block
                class="py-9"
              >
              {{activeBtn.cancelText || 'Cancel'}}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </template>
      <!-- BODY -->
      <v-card-text :class="{ 'px-0': window === 1 }">
        <v-container class="pt-0 px-0">
          <v-row dense v-if="player">
            <v-col cols="3">
              <v-img
                :src="player.profilePic"
                :aspect-ratio="1"
              ></v-img>
            </v-col>
            <v-col cols="9">
              <v-row>
                <v-col cols="12" :class="`text-h6 py-0 ${getDarkerColor(theme.color1, theme.color1Text)}`">
                  {{player.fullname}} <age-division-display :player="player" :usav="true"></age-division-display>
                  <book-mark
                    :ppid="player.id"
                    type="player"
                    :class="`${getDarkerColor(theme.color1, theme.color1Text)}--text`"
                  ></book-mark>
                </v-col>
                <v-col cols="12" class="text-subtitle-1 py-0">
                  {{cityState}}
                </v-col>
                <v-col cols="12" class="py-1" v-if="showMetrics">
                  {{player.metricsArray | pipeArray}}
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-window v-model="window">
            <v-window-item :key="0">
              <v-row dense>
                <v-col cols="12" class="text-h4" v-if="player">
                  Talent ID {{ player.firstName }}
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12">
                  <v-select
                    label="Readiness"
                    :items="[
                      { text: 'BEACH JUNIOR NATIONAL TEAMS', value: 'A' },
                      { text: 'NTDP TRAINING SERIES', value: 'B' },
                      { text: 'WATCH LIST', value: 'C' },
                      { text: 'NOT YET', value: 'D' }
                    ]"
                    v-model="iRating.rating1"
                    solo
                    color="color3"
                    hide-details
                    item-color="color3"
                  >
                  <template v-slot:item="{ item, attrs, on }">
                      <v-list-item v-on="on" v-bind="attrs">
                        <v-list-item-avatar>
                          <v-avatar
                            color="#152047"
                            size="36"
                          >
                            <span class="white--text text-h5">{{item.value}}</span>
                          </v-avatar>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-subtitle>
                            {{ item.text }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                    <template v-slot:selection="{ item }">
                      <v-list-item class="pl-0">
                        <v-list-item-avatar>
                          <v-avatar
                            color="#152047"
                            size="36"
                          >
                            <span class="white--text text-h5">{{item.value}}</span>
                          </v-avatar>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-subtitle>
                            {{ item.text }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12">
                  <v-select
                    label="Performance"
                    :items="[
                      { text1: 'LOW POTENTIAL', text2: 'LOW PERFORMANCE',value: 1},
                      { text1: 'LOW POTENTIAL', text2: 'MODERATE PERFORMANCE',value: 2},
                      { text1: 'LOW POTENTIAL', text2: 'HIGH PERFORMANCE',value: 3},
                      { text1: 'MODERATE POTENTIAL', text2: 'LOW PERFORMANCE',value: 4},
                      { text1: 'MODERATE POTENTIAL', text2: 'MODERATE PERFORMANCE',value: 5},
                      { text1: 'MODERATE POTENTIAL', text2: 'HIGH PERFORMANCE',value: 6},
                      { text1: 'HIGH POTENTIAL', text2: 'LOW PERFORMANCE',value: 7},
                      { text1: 'HIGH POTENTIAL', text2: 'MODERATE PERFORMANCE',value: 8},
                      { text1: 'HIGH POTENTIAL', text2: 'HIGH PERFORMANCE',value: 9}
                    ]"
                    item-value="value"
                    item-text="value"
                    v-model="iRating.rating2"
                    solo
                    color="color3"
                    item-color="color3"
                    hide-details
                  >
                    <template v-slot:item="{ item, attrs, on }">
                      <v-list-item v-on="on" v-bind="attrs">
                        <v-list-item-avatar>
                          <v-avatar
                            color="#152047"
                            size="36"
                          >
                            <span class="white--text text-h5">{{item.value}}</span>
                          </v-avatar>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-subtitle>
                            {{ item.text1 }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle>
                            {{ item.text2 }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                    <template v-slot:selection="{ item }">
                      <v-list-item  class="pl-0">
                        <v-list-item-avatar>
                          <v-avatar
                            color="#152047"
                            size="36"
                          >
                            <span class="white--text text-h5">{{item.value}}</span>
                          </v-avatar>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-subtitle>
                            {{ item.text1 }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle>
                            {{ item.text2 }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12" >
                  <v-textarea
                    label="Comments"
                    v-model="iRating.comments"
                    :solo="!iRating.comments"
                    :outlined="!!iRating.comments"
                    color="color3"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row dense v-if="player">
                <v-col cols="12" class="grey--text subtitle-2">
                  Your Talent ID history for {{  player.firstName }}
                </v-col>
                <v-col cols="12">
                  <v-list>
                    <template v-for="(h, i) in history.filter(f => !f.deleted)">
                      <v-list-item
                        :key="`item-${h.id}`"
                      >
                        <v-list-item-avatar :color="getColor(i)" class="white--text justify-center" size="64">
                          <div class="text-center title">{{ h.rating }}</div>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-slide-x-transition group leave-absolute mode="out-in">
                            <template v-if="!h.predelete">
                              <v-list-item-title key="content1">{{ displayDateTime(h.dtCreated) }}</v-list-item-title>
                              <v-list-item-subtitle key="content2">{{ h.comments }}</v-list-item-subtitle>
                            </template>
                            <template v-else>
                              <v-list-item-title key="content1">Delete this rating?</v-list-item-title>
                              <v-list-item-subtitle key="content2" class="white--text">?</v-list-item-subtitle>
                            </template>
                          </v-slide-x-transition>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-slide-x-transition group leave-absolute mode="out-in">
                            <template v-if="!h.predelete">
                              <v-btn small icon @click.stop="h.predelete = !h.predelete" key="btn1">
                                <v-icon color="grey lighten-1" small>
                                  {{ h.predelete ? 'fas fa-times-circle' : 'fas fa-trash'}}
                                </v-icon>
                              </v-btn>
                            </template>
                            <template v-else>
                              <v-btn
                                @click.stop="deleteRatings(h)"
                                color="success white--text"
                                key="btn2"
                                class="mr-1"
                              >
                                yes
                              </v-btn>
                              <v-btn
                                @click.stop="h.predelete = !h.predelete"
                                color="error white--text"
                                key="btn3"
                              >
                                no
                              </v-btn>
                            </template>
                          </v-slide-x-transition>
                          <v-fab-transition>
                          </v-fab-transition>
                        </v-list-item-action>
                      </v-list-item>
                      <v-divider :key="`div-${h.id}`" v-if="i < history.length - 1"></v-divider>
                    </template>
                  </v-list>
                </v-col>
              </v-row>
            </v-window-item>
          </v-window>
        </v-container>
        <v-overlay color="white" v-if="loading">
          <div class="text-center">
            <v-progress-circular indeterminate color="color3" size="64"></v-progress-circular>
          </div>
          <div class="color3--text text-center text-h4">Loading</div>
        </v-overlay>
      </v-card-text>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { localDate, localDt } from '@/Filters'
import BookMark from '@/components/Player/BookMark'
import { darkerColor } from '@/classes/Dark.js'
import AgeDivisionDisplay from '@/components/Player/AgeDivisionDisplay'

export default {
  props: ['player', 'view', 'noBtn'],
  data () {
    return {
      isOpen: false,
      iRating: {
        id: 0,
        rating1: null,
        rating2: null,
        comments: null
      },
      selectedRatting: null,
      window: 0,
      loading: false,
      history: [],
      saved: false
    }
  },
  computed: {
    ...mapGetters(['user', 'tournament', 'theme']),
    isNew () {
      return this.iRating && !this.iRating.id
    },
    activeBtn () {
      return {
        color: 'success white--text',
        icon: 'fas fa-times',
        onClick: this.postRatings,
        text: 'save',
        cancel: this.cancel,
        disabled: !this.valid,
        cancelText: this.dirty ? 'Cancel' : 'close'
      }
    },
    dirty () {
      const i = this.iRating
      return this.isNew ? !!(i.rating1 || i.rating2 || i.comments) : JSON.stringify(this.selectedRatting) !== JSON.stringify(i)
    },
    valid () {
      const i = this.iRating
      return i.rating1 && i.rating2
    },
    cityState () {
      if (this.player) {
        const a = []
        this.player.city && a.push(this.player.city)
        this.player.state && a.push(this.player.state)
        return a.join(', ')
      }
      return null
    },
    showMetrics () {
      return true // this.player && this.player.showMetrics((this.view || this.iView), this.user)
    },
    dto () {
      const i = this.iRating
      return {
        id: i.id,
        playerProfileId: this.player.id,
        rating: `${i.rating1}${i.rating2}`,
        comments: i.comments,
        tournamentId: this.tournament ? this.tournament.id : null
      }
    }
  },
  methods: {
    getColor (i) {
      return i % 2 === 0 ? '#152047' : '#ca9700'
    },
    displayDate (d) {
      return localDate(d)
    },
    displayDateTime (d) {
      return localDt(d)
    },
    init () {
      this.iRating = {
        id: 0,
        rating1: null,
        rating2: null,
        comments: null
      }
      this.selectedRatting = null
    },
    cancel (close) {
      this.init()
      if (this.isNew || close === true) this.isOpen = false
      this.window = 0
    },
    open () {
      this.isOpen = true
    },
    loadRatings () {
      this.history = []
      this.loading = true
      this.$VBL.user.ntdp.get(this.player.ppId || this.player.id)
        .then(r => {
          this.setHistory(r.data)
        })
        .catch(e => console.log(e.response))
        .finally(() => { this.loading = false })
    },
    postRatings () {
      this.loading = true
      this.$VBL.user.ntdp.post([this.dto])
        .then(r => {
          this.setHistory(r.data)
          this.saved = true
          this.$emit('change')
          this.init()
        })
        .catch(e => console.log(e.response))
        .finally(() => { this.loading = false })
    },
    getDarkerColor (color1, color2) {
      return darkerColor(color1, color2)
    },
    setHistory (h) {
      h.forEach(f => {
        f.predelete = false
      })
      this.history = h.sort((a, b) => { return new Date(b.dtCreated).getTime() - new Date(a.dtCreated).getTime() })
    },
    deleteRatings (rating) {
      this.loading = true
      this.$VBL.user.ntdp.delete(rating.id)
        .then(r => {
          rating.deleted = true
          this.$emit('change')
        })
        .catch(e => console.log(e.response))
        .finally(() => { this.loading = false })
    }
  },
  watch: {
    isOpen: function (val) {
      if (!val) {
        this.cancel()
      } else {
        this.loadRatings()
      }
    }
  },
  components: {
    BookMark,
    AgeDivisionDisplay
  }
}
</script>
